import { useDictionary } from '../../../../../utilities/hooks/UseDictionary';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { NavigatorPaths } from '../../../../../assets/dictionaries/NavigatorPaths';
import {  ReactComponent as StarFillIcon } from '../../../../../assets/icons/ic_star.svg';
import Tooltip from '../../../common/Tooltip';
import moment from 'moment';
import { useEffect, useState } from 'react';

const ReviewOverview = ({ providerInfo }) => {
	const dictionary = useDictionary();
	const history = useHistory();
	const [verificationStatus, setVerificationStatus] = useState(null);
	const isUserVerified = verificationStatus === 3;

	const onDetailsClicked = async () => {
		history.push(`${NavigatorPaths.provider_reviews.path}`);
	};

	const formatDate = (e) => {
		const date = new Date(e * 1000);
		return moment(date).format('MMM DD, YYYY');
	}

	useEffect(() => {
		if (providerInfo) {
			setVerificationStatus(providerInfo?.verification_status);
		}
	}, [providerInfo]);

	return (
		<>
			<div className="payouts-title-row">
				<h2 data-testid="payouts-header" className='fw-500'>{dictionary.providerReviews}</h2>
				{isUserVerified && (
					<div
						style={{ cursor: 'pointer' }}
						className="see-details font-family-roboto fw-500 text-with-underline"
						data-testid="see-details"
						onClick={onDetailsClicked}
					>
						{dictionary.see_details}
					</div>
				)}
			</div>
			<div className="payout-container payout-container-home" data-testid="pending-payouts" style={{marginBottom: '8px'}}>
				<div className='payout-text-area'>
					<span className='payout-text font-family-roboto' style={{fontWeight:500}}>{dictionary.rating}</span>
					<div className='text-with-info provider-payout-info home-payout-info'> <Tooltip content={dictionary.Average_customer_satisfaction} />
					</div>
				</div>
				<div className="payout-text-area" style={{gap:8}}>
					<h3 style={{fontWeight: 400}}>{parseFloat(providerInfo.avg_reviews/100).toFixed(1)}</h3>
					<StarFillIcon width={16} height={16} style={{ color: '#22264C' }}/>
				</div>
				<h4 style={{ fontSize: '12px', opacity: '0.6' }} className="truncate fw-400"
					title={`${dictionary.Total} ${providerInfo?.total_reviews}${providerInfo?.total_reviews ? `, ${dictionary.last_review.toLowerCase()} ${parseFloat(providerInfo?.last_review?.rating).toFixed(1)} (${dictionary.received} on ${formatDate(providerInfo?.last_review?.date)})` : ''}`}
				>
					{dictionary.Total} {providerInfo?.total_reviews}
					{providerInfo?.total_reviews ? `, ${dictionary.last_review.toLowerCase()} ${parseFloat(providerInfo?.last_review?.rating).toFixed(1)} ${providerInfo?.last_review?.date ? `(${dictionary.received} on ${formatDate(providerInfo.last_review.date)})` : ''}` : ''}
				</h4>
			</div>
		</>
	);
};

ReviewOverview.propTypes = {
	providerInfo: PropTypes.object
};

export default ReviewOverview;